import { List } from "@material-ui/core";
import { useCallback } from "react";
import { ResourceContextProvider, Title } from "react-admin";
import { useHistory } from "react-router-dom";
import resourceNames from "../../../common/data/resourceNames";
import { ReportItem } from "../../reports/ReportItem";

const title = `resources.${resourceNames.ADMIN_GEOMETRIS_COMMANDS}.name`;

export const GeometrisCommandsList = () => {
  const history = useHistory();
  const handleClick = useCallback(
    (commandName: string) => {
      history.push(`/admin-geometris-commands/${commandName}`);
    },
    [history]
  );

  return (
    <ResourceContextProvider value={resourceNames.ADMIN_GEOMETRIS_COMMANDS}>
      <div className="content-container">
        <Title title={title} />
        <List>
          <ReportItem
            name="reset-command"
            label="Reset ELD"
            description="Send a RESET command to a selected ELD, which restarts the main onboard application module"
            onClick={handleClick}
          />
          <ReportItem
            name="shipmode-command"
            label="Completely power down all ELD systems"
            description="Send a SHIPMODE command to a selected ELD. The ELD will only wake up after the ignition has been turned on"
            onClick={handleClick}
          />
          <ReportItem
            name="engine-bus-command"
            label="Change ELD engine bus protocol"
            description="Change between OBD, OBD2, J1708, J1939 and auto-detected engine bus modes for a selected ELD"
            onClick={handleClick}
          />
          <ReportItem
            name="reset-odometer-command"
            label="Set ELD odometer"
            description="Manually set the odometer value for a selected ELD"
            onClick={handleClick}
          />
          <ReportItem
            name="send-device-configuration"
            label="Send device configuration"
            description="Deploy the device configuration to a selected ELD"
            onClick={handleClick}
          />
          <ReportItem
            name="custom-command"
            label="Custom ELD command"
            description="Send a custom command to a selected ELD (advanced)"
            onClick={handleClick}
          />
        </List>
      </div>
    </ResourceContextProvider>
  );
};
